import axios from 'axios';

export const UNCERTAIN_WRITE_USER_MESSAGE = '操作结果暂未确认，请刷新页面后查看是否已生效。';

/** 两次都没拿到服务端响应：写入可能已生效，也可能没有，不能当成失败处理。 */
export class UncertainWriteError extends Error {
  readonly code = 'AI_SESSION_WRITE_RESULT_UNCERTAIN';

  constructor(options?: { cause?: unknown }) {
    super(UNCERTAIN_WRITE_USER_MESSAGE);
    this.name = 'UncertainWriteError';
    if (options?.cause !== undefined) this.cause = options.cause;
  }
}

// 无业务体的 503 由 API 客户端整页重载处理（维护中），这里不重放，避免与重载竞争。
const GATEWAY_STATUSES = new Set([502, 504]);

function hasServerVerdict(data: unknown): boolean {
  return Boolean(
    data && typeof data === 'object' && ('success' in data || 'code' in data || 'detail' in data)
  );
}

/** 请求没有得到服务端的判断：网络中断、超时，或网关返回的无业务体 5xx。 */
export function isUncertainWriteError(error: unknown): boolean {
  if (axios.isCancel(error) || !axios.isAxiosError(error)) return false;
  if (!error.response) return true;
  return GATEWAY_STATUSES.has(error.response.status) && !hasServerVerdict(error.response.data);
}

/**
 * 服务端对同一请求重放是幂等的（已处理则返回原结果，版本过期则报冲突），
 * 结果未知时用完全相同的参数重发一次，由服务端决定结果。
 */
export async function sendWithUncertainWriteReplay<T>(send: () => Promise<T>): Promise<T> {
  try {
    return await send();
  } catch (error) {
    if (!isUncertainWriteError(error)) throw error;
  }
  try {
    return await send();
  } catch (replayError) {
    if (isUncertainWriteError(replayError)) throw new UncertainWriteError({ cause: replayError });
    throw replayError;
  }
}
